import { createReducer, on } from '@ngrx/store';

import { UserHistoryItem } from '@user-history/entities/user-history-item';
import { userHistoryHomeAction } from '@home/store/actions/home.actions';

export const initialUserHistoryList: UserHistoryItem[] = [];

export const userHistoryListReducer = createReducer(
  initialUserHistoryList,
  on(userHistoryHomeAction, (state, { response }) => {
    return response;
  })
);
